<template>
  <div class="auth-page">
    <!-- Header -->
    <header class="auth-header">
      <div class="header-content">
        <a href="https://www.gobo.show" class="logo-link">
          <img src="/img/gobo-logo-white.svg" alt="Gobo" class="logo" />
        </a>
        <nav class="header-nav desktop-nav">
          <a href="https://tixlist.gobo.show" target="_blank">BUY TICKETS</a>
          <a href="https://www.gobo.show/?page_id=54" target="_blank"
            >WHY GOBO?</a
          >
          <a href="https://www.gobo.show/?page_id=55" target="_blank"
            >WHO WE'RE FOR</a
          >
          <a href="https://www.gobo.show/?page_id=56" target="_blank"
            >COMPARE</a
          >
          <a href="https://www.gobo.show/?page_id=57" target="_blank"
            >HOW IT WORKS</a
          >
          <a href="https://www.gobo.show/pro" target="_blank">GOBO PRO</a>
        </nav>
        <span class="header-auth-text desktop-nav">Log In or Sign Up</span>
        <button
          class="mobile-menu-btn"
          @click="mobileMenuOpen = !mobileMenuOpen"
        >
          <span class="hamburger-icon"></span>
        </button>
      </div>
      <!-- Mobile menu -->
      <nav v-if="mobileMenuOpen" class="header-nav mobile-nav">
        <a href="https://tixlist.gobo.show" target="_blank">BUY TICKETS</a>
        <a href="https://www.gobo.show/?page_id=54" target="_blank"
          >WHY GOBO?</a
        >
        <a href="https://www.gobo.show/?page_id=55" target="_blank"
          >WHO WE'RE FOR</a
        >
        <a href="https://www.gobo.show/?page_id=56" target="_blank">COMPARE</a>
        <a href="https://www.gobo.show/?page_id=57" target="_blank"
          >HOW IT WORKS</a
        >
        <a href="https://www.gobo.show/pro" target="_blank">GOBO PRO</a>
        <span class="header-auth-text">Log In or Sign Up</span>
      </nav>
    </header>

    <!-- Hero Section with H1 -->
    <div class="auth-hero">
      <h1 class="auth-hero-title">Log In or Sign Up</h1>
    </div>

    <!-- Main Content -->
    <div class="auth-content-wrapper">
      <div class="angled-white-bg">
        <main class="auth-main">
          <form class="auth-column" @submit.prevent="handleLoginSubmit">
            <h1 class="section-title">Login to your account</h1>
            <h4 class="section-subtitle">Create, view, or edit events.</h4>

            <div class="input-group">
              <label>Email</label>
              <div class="input-wrapper">
                <svg class="input-icon" viewBox="0 0 20 20" fill="currentColor">
                  <path
                    d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"
                  />
                  <path
                    d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"
                  />
                </svg>
                <input
                  v-model="loginEmail"
                  type="email"
                  placeholder="Email"
                  class="custom-input has-icon"
                  @input="loginError = ''"
                />
              </div>
              <p v-if="loginError" class="error-text">{{ loginError }}</p>
            </div>

            <div class="input-group">
              <label>Password</label>
              <div class="input-wrapper">
                <svg class="input-icon" viewBox="0 0 20 20" fill="currentColor">
                  <path
                    fill-rule="evenodd"
                    d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                    clip-rule="evenodd"
                  />
                </svg>
                <input
                  v-model="loginPassword"
                  type="password"
                  placeholder="Password"
                  class="custom-input has-icon"
                  @input="
                    loginError = '';
                    loginPasswordError = '';
                  "
                />
              </div>
              <p v-if="loginPasswordError" class="error-text">
                {{ loginPasswordError }}
              </p>
            </div>

            <a href="#" class="forgot-link">Forgot your password?</a>

            <div class="button-container">
              <button type="submit" class="primary-btn">Sign In</button>
            </div>
          </form>

          <div class="divider"></div>

          <form class="auth-column" @submit.prevent="handleCreateAccountSubmit">
            <h1 class="section-title">Sign up and get started</h1>
            <h4 class="section-subtitle">It's easy and it's free.</h4>

            <div class="input-group">
              <label>Name</label>
              <div class="input-wrapper">
                <svg class="input-icon" viewBox="0 0 20 20" fill="currentColor">
                  <path
                    fill-rule="evenodd"
                    d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                    clip-rule="evenodd"
                  />
                </svg>
                <input
                  v-model="createName"
                  type="text"
                  placeholder="Name"
                  class="custom-input has-icon"
                />
              </div>
            </div>

            <div class="input-group">
              <label>Email</label>
              <div class="input-wrapper">
                <svg class="input-icon" viewBox="0 0 20 20" fill="currentColor">
                  <path
                    d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"
                  />
                  <path
                    d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"
                  />
                </svg>
                <input
                  v-model="createEmail"
                  type="email"
                  placeholder="Email"
                  class="custom-input has-icon"
                />
              </div>
              <p v-if="createAccountError" class="error-text">
                {{ createAccountError }}
              </p>
            </div>

            <div class="input-group">
              <label>Password</label>
              <div class="input-wrapper">
                <svg class="input-icon" viewBox="0 0 20 20" fill="currentColor">
                  <path
                    fill-rule="evenodd"
                    d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                    clip-rule="evenodd"
                  />
                </svg>
                <input
                  v-model="createPassword"
                  type="password"
                  placeholder="Password"
                  class="custom-input has-icon"
                  @input="validatePassword"
                />
              </div>

              <div v-if="createPasswordError" class="password-rules">
                <p :class="passwordValidation.capital ? 'valid' : 'invalid'">
                  At least one uppercase letter
                </p>
                <p :class="passwordValidation.digit ? 'valid' : 'invalid'">
                  At least one digit
                </p>
                <p :class="passwordValidation.length ? 'valid' : 'invalid'">
                  Be longer than 6 characters
                </p>
              </div>
            </div>

            <div class="input-group">
              <div class="input-wrapper">
                <svg class="input-icon" viewBox="0 0 20 20" fill="currentColor">
                  <path
                    fill-rule="evenodd"
                    d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                    clip-rule="evenodd"
                  />
                </svg>
                <input
                  v-model="createConfirmPassword"
                  type="password"
                  placeholder="Confirm Password"
                  class="custom-input has-icon"
                />
              </div>
              <p v-if="confirmPasswordError" class="error-text">
                {{ confirmPasswordError }}
              </p>
            </div>

            <h4 class="terms-text">
              By signing up, you agree to our
              <a href="https://newsite.gobo.show/terms/" target="_blank"
                >Terms of Service</a
              >. Gobo takes a 5% commission on tickets sold, inclusive of credit
              card fees.
            </h4>

            <div class="button-container">
              <button type="submit" class="primary-btn">Create Account</button>
            </div>
          </form>
        </main>
      </div>
    </div>

    <!-- Footer -->
    <footer class="auth-footer">
      <div class="footer-content">
        <div class="footer-column">
          <h4>Gobo</h4>
          <a href="https://www.gobo.show/about-us/" target="_blank">About Us</a>
          <a href="https://www.gobo.show/blog/" target="_blank">Blog</a>
          <a href="https://www.gobo.show/media/" target="_blank">Media</a>
        </div>
        <div class="footer-column">
          <h4>Support Center</h4>
          <a
            href="https://www.gobo.show/faq-general-ticket-questions/"
            target="_blank"
            >General Questions</a
          >
          <a href="https://www.gobo.show/faq-ticket-buyers/" target="_blank"
            >Ticket Buyer FAQs</a
          >
          <a href="https://www.gobo.show/faq-ticket-sellers/" target="_blank"
            >Ticket Seller FAQs</a
          >
        </div>
        <div class="footer-column">
          <h4>General</h4>
          <a href="https://www.gobo.show/privacy-policy/" target="_blank"
            >Privacy Notice</a
          >
          <a href="https://www.gobo.show/terms/" target="_blank"
            >Terms of Service</a
          >
        </div>
      </div>
      <div class="footer-bottom">
        <p class="copyright">&copy; 2026 Gobo Show, Inc.</p>
        <div class="social-links">
          <a
            href="https://www.facebook.com/Goboshow"
            target="_blank"
            aria-label="Facebook"
          >
            <img src="/img/icons/Facebook.svg" alt="Facebook" />
          </a>
          <a
            href="https://www.instagram.com/goboshow"
            target="_blank"
            aria-label="Instagram"
          >
            <img src="/img/icons/Instagram.svg" alt="Instagram" />
          </a>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import store from "@/store";

export default {
  name: "AuthView",
  data() {
    return {
      mobileMenuOpen: false,
      loginEmail: "",
      loginPassword: "",
      loginError: "",
      loginPasswordError: "",

      createName: "",
      createEmail: "",
      createPassword: "",
      createConfirmPassword: "",
      createPasswordError: "",
      confirmPasswordError: "",
      createAccountError: "",
      passwordValidation: {
        capital: false,
        length: false,
        digit: false
      }
    };
  },
  methods: {
    validatePassword() {
      const password = this.createPassword;
      this.passwordValidation.capital = /(?=.*[A-Z])/.test(password);
      this.passwordValidation.length = /(?=.{6,}$)/.test(password);
      this.passwordValidation.digit = /(?=.*[0-9])/.test(password);

      return (
        this.passwordValidation.capital &&
        this.passwordValidation.length &&
        this.passwordValidation.digit
      );
    },

    async handleLoginSubmit() {
      this.loginError = "";
      this.loginPasswordError = "";

      try {
        const userCredential = await firebase
          .auth()
          .signInWithEmailAndPassword(this.loginEmail, this.loginPassword);

        // Check if user has completed onboarding
        const userDoc = await firebase
          .firestore()
          .collection("users")
          .doc(userCredential.user.uid)
          .get();

        const userData = userDoc.data();
        if (userData && !userData.onboardingComplete) {
          // Show onboarding modal via Vuex
          store.dispatch("showOnboarding", userData.name || "");
        } else if (userData && userData.eventCreated) {
          // User has created events, go to events list
          this.$router.push("/events");
        } else {
          // User has not created any events, initialize new event and go to create event
          store.dispatch("newEvent");
          this.$router.push({ name: "createEvent" });
        }
      } catch (error) {
        if (error.code === "auth/user-not-found") {
          this.loginError = "No account found with this email. Please sign up.";
        } else if (error.code === "auth/wrong-password") {
          this.loginPasswordError = "Incorrect password. Please try again.";
        } else {
          this.loginError = "An error occurred. Please try again.";
        }
      }
    },

    async handleCreateAccountSubmit() {
      this.createPasswordError = "";
      this.confirmPasswordError = "";
      this.createAccountError = "";

      if (!this.validatePassword()) {
        this.createPasswordError = "Password must contain:";
        return;
      }
      if (this.createPassword !== this.createConfirmPassword) {
        this.confirmPasswordError = "Passwords do not match.";
        return;
      }

      try {
        const currentUser = firebase.auth().currentUser;
        let user;

        if (currentUser && currentUser.isAnonymous) {
          const credential = firebase.auth.EmailAuthProvider.credential(
            this.createEmail,
            this.createPassword
          );
          const userCredential = await currentUser.linkWithCredential(
            credential
          );
          user = userCredential.user;
        } else {
          const userCredential = await firebase
            .auth()
            .createUserWithEmailAndPassword(
              this.createEmail,
              this.createPassword
            );
          user = userCredential.user;
        }

        const userData = {
          name: this.createName,
          email: this.createEmail,
          uid: user.uid,
          pro: true
        };
        await firebase
          .firestore()
          .collection("users")
          .doc(user.uid)
          .set(userData);

        // Show onboarding modal via Vuex instead of redirecting
        store.dispatch("showOnboarding", this.createName);
      } catch (error) {
        if (error.code === "auth/email-already-in-use") {
          this.createAccountError =
            "This email is already in use. Please try another one.";
        } else {
          console.error("Error creating account:", error);
          this.createAccountError = "An error occurred during sign up.";
        }
      }
    }
  }
};
</script>

<style scoped>
/* Page Layout */
.auth-page {
  min-height: 100vh;
  background-color: #2b2b2b;
  display: flex;
  flex-direction: column;
  font-family: "Rubik", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, Helvetica, sans-serif;
}

/* Header Styles */
.auth-header {
  background-color: #2b2b2b;
  position: relative;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1.25rem 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo-link {
  display: flex;
  align-items: center;
}

.logo {
  height: 32px;
  width: auto;
}

.header-nav {
  display: flex;
  gap: 1.5rem;
}

.header-nav a {
  color: #ffffff;
  text-decoration: none;
  font-size: 0.8rem;
  font-weight: 500;
  letter-spacing: 0.5px;
  transition: color 0.2s ease;
}

.header-nav a:hover {
  color: #22a588;
}

.desktop-nav {
  display: none;
}

@media (min-width: 1024px) {
  .desktop-nav {
    display: flex;
  }
}

.mobile-menu-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
}

@media (min-width: 1024px) {
  .mobile-menu-btn {
    display: none;
  }
}

.hamburger-icon {
  display: block;
  width: 24px;
  height: 2px;
  background-color: #ffffff;
  position: relative;
}

.hamburger-icon::before,
.hamburger-icon::after {
  content: "";
  position: absolute;
  width: 24px;
  height: 2px;
  background-color: #ffffff;
  left: 0;
}

.hamburger-icon::before {
  top: -7px;
}

.hamburger-icon::after {
  top: 7px;
}

.mobile-nav {
  flex-direction: column;
  padding: 1rem 2rem 1.5rem;
  gap: 1rem;
  background-color: #2b2b2b;
}

.header-auth-text {
  color: #ffffff;
  font-size: 0.875rem;
  font-weight: 500;
  margin-left: 1.5rem;
}

/* Hero Section */
.auth-hero {
  background-color: #2b2b2b;
  padding: 3rem 2rem 4rem;
}

.auth-hero-title {
  color: #ffffff;
  font-size: 2.5rem;
  font-weight: 700;
  text-align: left;
  text-transform: none;
  margin: 0;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 2rem;
}

@media (min-width: 768px) {
  .auth-hero-title {
    font-size: 3rem;
  }
}

/* Main Content Wrapper */
.auth-content-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 2rem 0;
}

/* The White Angled Box */
.angled-white-bg {
  background-color: #ffffff;
  width: 100%;
  padding: 4rem 2rem;
  /* Top and bottom diagonal cut */
  clip-path: polygon(0 3vw, 100% 0, 100% calc(100% - 3vw), 0 100%);
  display: flex;
  justify-content: center;
}

.auth-main {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1024px;
  gap: 3rem;
}

@media (min-width: 1024px) {
  .auth-main {
    flex-direction: row;
    align-items: flex-start;
  }
}

.auth-column {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.divider {
  display: none;
  width: 1px;
  background-color: #e5e7eb;
  align-self: stretch;
  margin: 0 1rem;
}

@media (min-width: 1024px) {
  .divider {
    display: block;
  }
}

/* Typography */
.section-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 0.25rem 0;
}

.section-subtitle {
  font-size: 1rem;
  font-weight: 400;
  color: #6b7280;
  margin: 0 0 2rem 0;
}

/* Form Inputs & Icons */
.input-group {
  margin-bottom: 1.25rem;
  display: flex;
  flex-direction: column;
}

.input-group label {
  display: block;
  font-size: 0.875rem;
  color: #6b7280;
  margin-bottom: 0.5rem;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}

.input-icon {
  position: absolute;
  left: 0.85rem;
  width: 1.15rem;
  height: 1.15rem;
  color: #6b7280;
}

.custom-input {
  width: 100%;
  background-color: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
  padding: 0.85rem 1rem;
  font-size: 1rem;
  color: #1f2937;
  font-family: inherit;
  box-sizing: border-box;
}

/* Adds padding to the left so text doesn't type over the icons */
.custom-input.has-icon {
  padding-left: 2.75rem;
}

.custom-input::placeholder {
  color: #9ca3af;
}

.custom-input:focus {
  outline: none;
  border-color: #0d9488;
  box-shadow: 0 0 0 1px #0d9488;
}

/* Links & Buttons */
.forgot-link {
  color: #0d9488;
  font-weight: 600;
  font-size: 0.875rem;
  text-decoration: underline;
  margin-bottom: 1.5rem;
  display: inline-block;
  align-self: flex-start;
}

.forgot-link:hover {
  color: #115e59;
}

.button-container {
  text-align: left;
  margin-top: 0.5rem;
}

.primary-btn {
  background-color: #0d9488;
  color: white;
  padding: 0.6rem 1.8rem;
  border-radius: 0.25rem;
  font-weight: 400; /* Fixed: Removed bolding */
  border: none;
  cursor: pointer;
  font-size: 1rem;
  font-family: inherit;
}

.primary-btn:hover {
  background-color: #115e59;
}

/* Rules & Errors */
.error-text {
  color: #ef4444;
  font-size: 0.875rem;
  margin-top: 0.25rem;
}

.password-rules {
  margin-top: 0.5rem;
  margin-left: 1rem;
}

.valid {
  color: #16a34a;
  font-size: 0.875rem;
  margin: 0.125rem 0;
}

.invalid {
  color: #ef4444;
  font-size: 0.875rem;
  margin: 0.125rem 0;
}

.terms-text {
  font-size: 0.85rem;
  color: #374151;
  font-weight: 400;
  margin-bottom: 1.5rem;
  line-height: 1.4;
}

.terms-text a {
  color: #0d9488;
  text-decoration: underline;
}

/* Footer Styles */
.auth-footer {
  background-color: #2b2b2b;
  padding: 3rem 2rem 2rem;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
}

@media (min-width: 768px) {
  .footer-content {
    grid-template-columns: repeat(3, 1fr);
  }
}

.footer-column {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.footer-column h4 {
  color: #ffffff;
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
}

.footer-column a {
  color: #9ca3af;
  text-decoration: none;
  font-size: 0.875rem;
  transition: color 0.2s ease;
}

.footer-column a:hover {
  color: #22a588;
}

.footer-bottom {
  max-width: 1200px;
  margin: 2rem auto 0;
  padding-top: 1.5rem;
  border-top: 1px solid #4b5563;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

@media (min-width: 768px) {
  .footer-bottom {
    flex-direction: row;
    justify-content: space-between;
  }
}

.copyright {
  color: #9ca3af;
  font-size: 0.875rem;
  margin: 0;
}

.social-links {
  display: flex;
  gap: 1rem;
}

.social-links a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  transition: opacity 0.2s ease;
}

.social-links a:hover {
  opacity: 0.8;
}

.social-links img {
  width: 24px;
  height: 24px;
  filter: brightness(0) invert(1);
}
</style>
